// @ts-nocheck

import { createSelector } from 'reselect';

import { Target } from '../../../../client';
import { getLang } from '../../../../i18n/l10n';
import { SpineAnimationIds } from '../../../../types/animations';
import { Locales } from '../../../../types/common';
import { SoundIds } from '../../../../types/sounds';
import { selectBoomGlobalSkinId } from '../../../boom/selectors/global/globalPrimary.selector';
import { BoomSkinIds } from '../../../boom/types/global';

const selectAnimationId = createSelector([selectBoomGlobalSkinId], (boomSkinId) => {
  const lang = getLang();
  if (boomSkinId === BoomSkinIds.VALENTINE) {
    if (lang === Locales.DE) {
      return SpineAnimationIds.BOOM_VALENTINE_START_DE;
    }
    if (lang === Locales.EN) {
      return SpineAnimationIds.BOOM_VALENTINE_START_EN;
    }
    if (lang === Locales.ES) {
      return SpineAnimationIds.BOOM_VALENTINE_START_ES;
    }
    if (lang === Locales.FR) {
      return SpineAnimationIds.BOOM_VALENTINE_START_FR;
    }
  }
  if (boomSkinId === BoomSkinIds.PATRICK) {
    return SpineAnimationIds.BOOM_PATRICK_START;
  }
  return null;
});

const selectBoomWelcomeAnimationProps = createSelector([selectAnimationId], (animationId) => ({
  animationId,
  soundId: Target.__MOBILE__ ? SoundIds.BOOM_START : undefined,
}));

export default selectBoomWelcomeAnimationProps;
